import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import {Row,Col} from 'react-flexbox-grid'
import 'cropperjs/dist/cropper.css'
import { MuiPickersUtilsProvider, TimePicker, DatePicker } from 'material-ui-pickers';


import './styles.css'

class BusquedaAvanzadaModal extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            cleanSuper: this.props.filtros && this.props.filtros.idSuperRubro ? false : true, // Estos state son para que al principio del campo desplegable no hayan opciones
            cleanRub: this.props.filtros && this.props.filtros.idRubro ? false : true,
            cleanSub: this.props.filtros && this.props.filtros.idSubRubro ? false : true,

        }
    }

    handleCleanSup = (e) => {
        this.setState({
            cleanSuper : false
        })
        this.props.handleIdSuperRubro(e)
    }

    handleCleanRub = (e) => {
        this.setState({
            cleanRub : false
        })
        this.props.handleIdRubro(e)
    }

    handleCleanSub = (e) => {
        this.setState({
            cleanSub : false
        })
        this.props.handleIdSubRubro(e)
    }

    handleOnVolver = () => {
        /*this.setState({
            cleanSuper:true,
            cleanRub:true,
            cleanSub:true
        })*/
        this.props.handleCloseModal()
    }

    
    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className='busquedaAvanzada'
            >
                <DialogContent >
                    <DialogContentText id="alert-dialog-description">

                        {/* TITLE */}
                        <Row >
                            <Col xs={12} className='title' >
                                <div >Búsqueda avanzada</div>
                            </Col>
                        </Row>
                        
                        {/* SEPARADOR */}
                        <Row >
                            <Col xs={12} className='separador' >
                            </Col>
                        </Row>


                        {/* COMBO SUPER */}
                        <Row>
                        <Col xs={12} className='contenido'> 
                                <TextField className='filterInput'
                                    //style={{width: '280px' , height: '45px', marginRight: '16px'}}
                                    style = {{textAlign:'left'}}
                                    fullWidth
                                    select              
                                    label='Superrubro'     
                                    value= {this.state.cleanSuper === true && this.props.superRubroUnico === false? '' : this.props.filtros.idSuperRubro}                                    
                                    name = 'idSuperRubro'
                                    onChange = {this.handleCleanSup}>                                    
                                    {this.props.superRubros !== undefined ? this.props.superRubros.map((e) => 
                                        <MenuItem key={e.idSuperRubro} value={e.idSuperRubro} >
                                            {e.nombre}
                                        </MenuItem>
                                    ): ''}
                                </TextField>                                
                            </Col>
                        </Row>
                        
                        {/* COMBO RUBRO */}
                        <Row>
                        <Col xs={12} className='contenido'> 
                                <TextField className='filterInput'
                                    //style={{width: '280px' , height: '45px', marginRight: '16px'}}
                                    style = {{textAlign:'left'}}
                                    fullWidth
                                    select              
                                    label='Rubro'     
                                    value= {this.state.cleanRub === true ? '' : this.props.filtros.idRubro}
                                    name = 'idSuperRubro'
                                    onChange = {this.handleCleanRub}>

                                    {this.props.rubros !== undefined ? this.props.rubros.map((e) =>{ 
                                        return(e.idSuperRubro === this.props.filtros.idSuperRubro &&
                                        <MenuItem key={e.idRubro} value={e.idRubro} >
                                            {e.nombre}
                                        </MenuItem>
                                    )}): ''}
                                </TextField>                                
                            </Col>
                        </Row>

                        {/* COMBO SUBRUBRO */}
                        <Row>
                        <Col xs={12} className='contenido'> 
                                <TextField className='filterInput'
                                    //style={{width: '280px' , height: '45px', marginRight: '16px'}}
                                    style = {{textAlign:'left'}}
                                    fullWidth
                                    select              
                                    label='Subrubro'     
                                    value= {this.state.cleanSub === true ? '' : this.props.filtros.idSubRubro}
                                    name = 'idSubRubro'
                                    onChange = {this.handleCleanSub}>

                                    {this.props.subrubros !== undefined ? this.props.subrubros.map((e) =>{ 
                                        return(e.idRubro === this.props.filtros.idRubro &&
                                        <MenuItem key={e.idSubrubro} value={e.idSubrubro} >
                                            {e.nombre}
                                        </MenuItem>
                                    )}): ''}
                                </TextField>                                
                            </Col>
                        </Row>

                        {/* NOMBRE ARTICULO */}
                        <Row>                    
                            <Col xs={12} className='contenido'>
                                <TextField className='filterInput'
                                    //style={{width: '280px' , height: '45px', marginRight: '16px'}}                                        
                                    fullWidth
                                    name = 'idArticulo'
                                    label='Artículo'
                                    error = {this.props.validarNombre() ? false: true}
                                    helperText = {this.props.validarNombre() ? '' : 'Cadena demasiado larga. Reingrese.'}
                                    value = {this.props.filtros.Nombre}
                                    onChange={this.props.handleNombreArticulo}
                                />
                            </Col>
                        </Row>

                        {/* CODIGO ARTICULO */}                        
                        <Row>                    
                            <Col xs={12} className='contenido'>
                                <TextField className='filterInput'
                                    //style={{width: '280px' , height: '45px', marginRight: '16px'}}                                        
                                    fullWidth
                                    name = 'idCodigo'
                                    label='Codigo '
                                    error = {this.props.validarCodigo() ? false: true}
                                    helperText = {this.props.validarCodigo() ? '' : 'Cadena demasiado larga. Reingrese.'}
                                    value = {this.props.filtros.Codigo}
                                    onChange={this.props.handleCodigoArticulo}
                                />
                            </Col>
                        </Row>
                    </DialogContentText>
                </DialogContent>

                <DialogActions className='' id='ecommerce'>
                    <Button onClick={this.handleOnVolver} className="btnSecundario">
                        VOLVER
                    </Button>
                    <Button onClick={this.props.handleOnAdvanceSearch} className="btnPrincipal">
                        BUSCAR
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}


export default BusquedaAvanzadaModal